var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16","width":"16","height":"16"}},[_c('path',{attrs:{"d":"M4.464 7.087L8 10.623l3.536-3.536a1 1 0 1 0-1.415-1.414L8 7.794 5.879 5.673a1 1 0 0 0-1.415 1.414z","clip-rule":"evenodd","opacity":".84"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }